<template>
  <div>
    <vue-element-loading
      is-full-screen
      :active="loading || !regised"
      spinner="bar-fade-scale"
      style="z-index:99999"
      color="#152d51"
    />
    <div class="px-5" v-if="ncapOption && ncapOption.length">
      <div class="mb-2 flex-all-center">
        <div>
          <v-img
            class="my-0 radius-circle"
            style="width:170px;height:auto"
            src="@/assets/logo_long.png"
          ></v-img>
        </div>
      </div>
      <div class="text-gray">บัญชีสินเชื่อเช่าซื้อ</div>
      <v-select
        v-model="selectContact"
        class="mt-5"
        :items="ncapOption"
        label="เลือกสัญญา"
        dense
        outlined
      ></v-select>
    </div>
    <div
      v-else-if="!ncapOption.length && !nmnyOption.length"
      style="display: flex; justify-content: center; align-items: center; flex-direction: column;"
    >
      <div class="mb-2 flex-all-center">
        <div>
          <v-img
            class="my-0 radius-circle"
            style="width: 170px; height: auto"
            src="@/assets/logo_long.png"
          ></v-img>
        </div>
        <div>
          <v-img
            class="my-0 radius-circle"
            style="width: 170px; height: auto"
            src="@/assets/logo_long_nm.png"
          ></v-img>
        </div>
      </div>
      <div class="text-center mb-8">
        ไม่มีสัญญาที่อยู่ระหว่างการรอชำระ
      </div>
      <v-btn
        :loading="loading"
        @click="close"
        class="main-btn col-8"
        style="color: white"
        color="#23409a"
      >
        กลับสู่แชท
      </v-btn>
    </div>

    <div v-if="nmnyOption && nmnyOption.length" class="mt-8">
      <div class="mb-2 flex-all-center">
        <div>
          <v-img
            class="my-0 radius-circle"
            style="width:170px;height:auto"
            src="@/assets/logo_long_nm.png"
          ></v-img>
        </div>
      </div>
      <div class="px-5">
        <div class="text-gray">บัญชีสินเชื่อจำนำเล่มทะเบียน</div>
        <v-select
          v-model="selectContact"
          class="mt-5"
          :items="nmnyOption"
          label="เลือกสัญญา"
          dense
          outlined
        ></v-select>
      </div>
    </div>

    <div
      class="mt-5 w-100 flex-all-center"
      v-if="(ncapOption && ncapOption.length) || (nmnyOption && nmnyOption.length)"
    >
      <v-btn
        @click="clickShow"
        :disabled="!selectContactdata"
        large
        class="col-8 main-btn"
        style="color:white"
        color="#23409A"
        >ถัดไป</v-btn
      >
    </div>
    <v-dialog
      v-model="show"
      scrollable
      fullscreen
      persistent
      max-width="500px"
      transition="dialog-bottom-transition"
    >
      <v-card class="py-2 px-5">
        <v-toolbar
          dark
          class="position-fixed col-12"
          style="height: 56px; top: 0; z-index: 2"
          :color="color"
        >
          <v-btn style="width:48xp" icon dark @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title class="w-100 text-center" style="margin-left:-48px"
            >รายละเอียดยอด</v-toolbar-title
          >
        </v-toolbar>
        <div style="margin-top:80px;background-color:white">
          <div class="mb-3 flex-all-center">
            <div>
              <v-img
                v-if="source == 'nmny'"
                class="radius-circle"
                style="width:100px;height:auto"
                src="@/assets/logo_h2_nm.png"
              ></v-img>
              <v-img
                v-else
                class="radius-circle"
                style="width:100px;height:auto"
                src="@/assets/logo_h.png"
              ></v-img>
            </div>
          </div>
          <h6 class="pl-5 text-blue mb-8" :style="`color: ${color} !important`">
            รายละเอียดสัญญา และยอดชำระ
          </h6>
          <contractTable
            v-if="selectContactdata && selectContactdata.model"
            :showData="selectContactdata"
            :color="color"
          />
          <div class="mb-5 w-100 flex-all-center">
            <v-btn
              @click="$router.push('/paymentgenerate')"
              large
              class="main-btn"
              style="color:white"
              :color="color"
              >ขอบาร์โค้ด/คิวอาร์โค้ดเพื่อชำระเงิน</v-btn
            >
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import moment from 'moment'
import api from '@/api'
import contractApi from '@/api/contract'
import config from '@/config'
import contractTable from '@/components/contractTable.vue'
import { formatThaiDate } from '@/utils/dateFormat'
export default {
  components: { VueElementLoading, contractTable },
  props: {
    userData: {
      default: null
    }
  },
  data() {
    return {
      show: false,
      loading: true,
      ncapContactList: [],
      nmnyContactList: null,
      selectContact: '',
      source: 'ncap'
    }
  },
  computed: {
    query() {
      return this.$store.state.query
    },
    view() {
      return this.$store.state.query.view
    },
    profile() {
      return this.$store.state.profile
    },
    userId() {
      return this.$store.state.profile.userId
    },
    regised() {
      if (this.userId && this.userData && this.userData.cardnumber) {
        return true
      } else {
        return false
      }
    },
    ncapOption() {
      let data = []
      if (this.ncapContactList) {
        this.ncapContactList.forEach(ele => {
          data.push(`เลขที่สัญญา ${ele.agreementNo}`)
        })
      }
      return data
    },
    nmnyOption() {
      let data = []
      if (this.nmnyContactList) {
        this.nmnyContactList.forEach(ele => {
          data.push(`เลขที่สัญญา ${ele.agreementNo}`)
        })
      }
      return data
    },
    selectContactdata() {
      if (this.selectContact) {
        let id = this.selectContact.split(' ')
        id = id[1]
        let data = this.ncapContactList.find(ele => ele.agreementNo == id)
        this.source = 'ncap'
        if (!data) {
          this.source = 'nmny'
          data = this.nmnyContactList.find(ele => ele.agreementNo == id)
        }
        this.$store.dispatch('setContactSource', this.source)
        this.$store.dispatch('setContact', data)
        this.$store.dispatch('setUserData', this.userData)
        return data
      } else {
        return null
      }
    },
    color() {
      if (this.source == 'nmny') {
        return '#007a47'
      }
      return '#23409a'
    }
  },
  watch: {
    userData: {
      immediate: true,
      deep: true,
      handler(userData) {
        if (userData && userData.cardnumber) {
          this.setup()
        }
      }
    }
  },

  mounted() {
    // this.setup();
  },
  methods: {
    async setup() {
      await this.fetchContact()
    },
    async clickShow() {
      this.loading = true
      try {
        this.selectContactdata.system_call = moment(new Date()).format('DD/MM/YYYY HH:mm')
      } catch (error) {
        this.selectContactdata.system_call = 'error'
      }
      let body = {
        userid: `${this.userid}`,
        pageid: config.pageid,
        textJson: JSON.stringify(this.selectContactdata)
      }
      let res = await api.setJsonVar(body)
      if (res) {
        this.loading = false
        if (
          (await window.liff.isInClient()) &&
          this.selectContactdata?.agreementNo &&
          this.source
        ) {
          // this.$store.dispatch('sendMessage', 'ระบบแสดงรายละเอียดยอด')
          this.$store.dispatch(
            'sendMessage',
            `showDetailNextCapLoanInfo&&${this.selectContactdata.agreementNo}&&${this.source}`
          )
        }
        this.show = true
      } else {
        this.loading = false
        this.$swal.fire({
          type: 'error',
          text: 'เรียกข้อมูลไม่สำเร็จ'
        })
      }
    },
    // async fetchContact() {
    //   let body = {
    //     IDCard: this.userData.cardnumber,
    //     BirthDay: moment(this.userData.dob).format("DD/MM/YYYY"),
    //     pageid: config.pageid,
    //   };
    //   let res = await api.getContact(body);
    //   this.loading = false;
    //   if (res && res.responsecode == 200) {
    //     this.ncapContactList = res.data;
    //     if (this.ncapContactList.length === 1) {
    //       this.selectContact = `เลขที่สัญญา ${this.ncapContactList[0].agreementNo}`;
    //       this.clickShow();
    //     }
    //   } else {
    //     this.$swal.fire({
    //       type: "error",
    //       text: "ไม่สามารถแสดงข้อมูลเลขที่สัญญาได้ในขณะนี้ กรุณาลองใหม่อีกครั้งภายหลัง",
    //     });
    //   }
    // },

    async fetchContact() {
      this.loading = true
      try {
        const configApi = {
          body: {
            page_id: config.pageid,
            id_card: this.userData.cardnumber,
            birth_day: formatThaiDate(this.userData.dob)
          },
          config: {}
        }
        const response = await contractApi.getLoanInfo(configApi)
        this.ncapContactList = response?.data?.data?.ncapLoanInfoList
        this.nmnyContactList = response?.data?.data?.nmnyLoanInfoList
        const ncapContactLength = this.ncapContactList.length || 0
        const nmnyContactLength = this.nmnyContactList.length || 0
        const totalContact = ncapContactLength + nmnyContactLength
        if (totalContact <= 1) {
          if (this.ncapContactList.length === 1) {
            this.selectContact = `เลขที่สัญญา ${this.ncapContactList[0].agreementNo}`
            this.clickShow()
          } else if (this.nmnyContactList.length === 1) {
            this.selectContact = `เลขที่สัญญา ${this.nmnyContactList[0].agreementNo}`
            this.clickShow()
          }
        }
      } catch (error) {
        console.error(error)
        this.$swal.fire({
          type: 'error',
          text: 'เรียกข้อมูลไม่สำเร็จ'
        })
      } finally {
        this.loading = false
      }
    },
    close() {
      this.$liff.closeWindow()
    }
  }
}
</script>

<style>
.v-text-field--outlined.v-input--dense .v-label--active {
  background-color: white;
  /* top: 14px !important; */
}
</style>
